// extracted by mini-css-extract-plugin
export default {"chart-parent":"ChartStyles_chart-parent__Po6Qj"};